import Footer from './Footer';

export default Footer;



// WEBPACK FOOTER //
// ../core/src/components/Footer/index.js